import { getFetch, postFetch, deleteFetch } from '../utils/fetch';

const VERSION1 = '/api/v1';

// This endpoint is used to check if the feature is enabled for a course,
// and can hit CW to see if the isbn is enabled for the feature
export const getFlagByCourseId = async (courseId, featureName) => {
  const apiHost = window.config.GRADEBOOK_API_URL;

  const response = await getFetch(
    `${apiHost}${VERSION1}/courses/${courseId}/features/${featureName}/status`,
  );
  if (!response.ok) {
    throw new Error('Unable to get feature status');
  }
  return response.json();
};

// This endpoint is used to check if the feature is enabled for a course or isbn
// It should only be used by the admin panel.
// If supporting a feature, use getFlagByCourseId
export const getFlagStatus = async (flaggingId, flaggingType, featureName) => {
  const apiHost = window.config.GRADEBOOK_API_URL;

  let flaggingUrl = '';
  if (flaggingType === 'course') {
    flaggingUrl = `courses`;
  } else if (flaggingType === 'isbn') {
    flaggingUrl = `isbns`;
  }
  const response = await getFetch(
    `${apiHost}${VERSION1}/${flaggingUrl}/${flaggingId}/features/${featureName}`,
  );
  if (!response.ok) {
    throw new Error('Unable to get feature status');
  }
  return response.json();
};

export const getFlagStatusBulk = async (flaggingType, featureName) => {
  const apiHost = window.config.GRADEBOOK_API_URL;
  const response = await getFetch(
    `${apiHost}${VERSION1}/features/${featureName}/${flaggingType}s`,
  );
  if (!response.ok) {
    throw new Error('Unable to get bulk feature status');
  }
  return response.json();
};

export const saveFeatureBulk = async (
  flaggingType,
  flaggingIds,
  featureName,
) => {
  const apiHost = window.config.GRADEBOOK_API_URL;

  // Only add ids if that what's been updated
  const body = {};
  if (flaggingType === 'course') {
    body.courseIds = flaggingIds;
  }
  if (flaggingType === 'isbn') {
    body.isbnIds = flaggingIds;
  }

  const response = await postFetch(
    `${apiHost}${VERSION1}/features/${featureName}/${flaggingType}s`,
    body,
  );
  if (!response.ok) {
    throw new Error('Unable to bulk add features');
  }
};

export const removeFeatureBulk = async (
  flaggingType,
  flaggingIds,
  featureName,
) => {
  const apiHost = window.config.GRADEBOOK_API_URL;

  // Only remove ids if that what's been updated
  const body = {};
  if (flaggingType === 'course') {
    body.courseIds = flaggingIds;
  }
  if (flaggingType === 'isbn') {
    body.isbnIds = flaggingIds;
  }

  const response = await deleteFetch(
    `${apiHost}${VERSION1}/features/${featureName}/${flaggingType}s`,
    body,
  );
  if (!response.ok) {
    throw new Error('Unable to bulk remove features');
  }
};
